// UUID v4 generator. Native `crypto.randomUUID()` is alleen beschikbaar in
// een "secure context" (HTTPS of localhost). Op een intern IP-adres via HTTP
// (zoals tijdens lokaal testen achter een reverse proxy) is dat niet zo.
// We vallen daarom terug op `crypto.getRandomValues`, dat wel beschikbaar is
// in alle moderne browsers, ook zonder secure context.

export function randomUUID(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    try {
      return crypto.randomUUID();
    } catch {
      // Sommige browsers gooien hier nog een SecurityError; val door naar fallback.
    }
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Zet version (4) en variant (10xx) bits per RFC 4122.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
  return (
    hex.slice(0, 4).join("") +
    "-" +
    hex.slice(4, 6).join("") +
    "-" +
    hex.slice(6, 8).join("") +
    "-" +
    hex.slice(8, 10).join("") +
    "-" +
    hex.slice(10, 16).join("")
  );
}
